<h2 class="modal-title">Import des codes dans la DB</h2>
@if (isImporting) {
  <div class="import-modal">
    @if (isLoading) {
      <div class="importation-card">
        <div class="spinner" aria-hidden="true"></div>
        <div class="ml20">
          <div class="f16">Importation des codes en cours, veuillez patienter...</div>
          <div class="sub">{{ getCounterByStatus([COMPLETED, ERROR]) }}/{{ getTotalCounter() }} terminés</div>
        </div>
      </div>
    } @else {
      <div class="importation-card">
        <div class="ml20">
          <div class="f16">Importation des codes terminée.</div>
          <div class="sub">{{ getCounterByStatus([COMPLETED, ERROR]) }}/{{ getTotalCounter() }} terminés</div>
        </div>
      </div>
    }

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <span>Thésaurus</span>
        </div>
      </div>
      <div class="progress-grid">
        @for (thesaurusCode of availableThesaurusCodeTypes; track $index) {
          @if (thesaurusCode?.selected) {
            <div class="progress-item">
              <div class="progress-item-txt">
                <span>{{ thesaurusCode.type }}</span>
                <span class="status"
                      [ngClass]="thesaurusCode?.progressInfos?.status === COMPLETED ? 'ok' : thesaurusCode?.progressInfos?.status === WAITING ? 'wait' : thesaurusCode?.progressInfos?.status === IN_PROGRESS ? 'run' : 'error'">
                  {{ getStatusHr(thesaurusCode.progressInfos.status) }}
                </span>
              </div>
              @if (thesaurusCode.progressInfos.status === COMPLETED) {
                <div class="meta">
                  @if (thesaurusCode?.progressInfos?.injectedCode != null) {
                    <span>Créés&nbsp;: {{ thesaurusCode?.progressInfos?.injectedCode }}</span>
                  }
                  @if (thesaurusCode?.progressInfos?.updatedCode != null) {
                    <span>Modifiés&nbsp;: {{ thesaurusCode?.progressInfos?.updatedCode }}</span>
                  }
                </div>
              }
              <div class="progress-bar"
                   [ngClass]="thesaurusCode.progressInfos.status === COMPLETED ? 'green' : ''"></div>
            </div>
          }
        }
      </div>
    </div>

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <span>Assurance</span>
        </div>
      </div>
      <div class="progress-grid">
        @for (insuranceCode of availableInsuranceCodeTypes; track $index) {
          @if (insuranceCode?.selected) {
            <div class="progress-item">
              <div class="progress-item-txt">
                <span>{{ insuranceCode.type }}</span>
                <span class="status"
                      [ngClass]="insuranceCode?.progressInfos?.status === COMPLETED ? 'ok' : insuranceCode?.progressInfos?.status === WAITING ? 'wait' : insuranceCode?.progressInfos?.status === IN_PROGRESS ? 'run' : 'error'">
                  {{ getStatusHr(insuranceCode.progressInfos.status) }}
                </span>
              </div>
              @if (insuranceCode.progressInfos.status === COMPLETED) {
                <div class="meta">
                  @if (insuranceCode?.progressInfos?.injectedCode != null) {
                    <span>Créés&nbsp;: {{ insuranceCode?.progressInfos?.injectedCode }}</span>
                  }
                  @if (insuranceCode?.progressInfos?.updatedCode != null) {
                    <span>Modifiés&nbsp;: {{ insuranceCode?.progressInfos?.updatedCode }}</span>
                  }
                </div>
              }
              <div class="progress-bar"
                   [ngClass]="insuranceCode.progressInfos.status === COMPLETED ? 'green' : ''"></div>
            </div>
          }
        }
      </div>
    </div>

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <span>Tarification</span>
        </div>
      </div>
      <div class="progress-grid">
        @for (tarificationCode of availableTarificationCodeTypes; track $index) {
          @if (tarificationCode?.selected) {
            <div class="progress-item">
              <div class="progress-item-txt">
                <span>{{ tarificationCode.type }}</span>
                <span class="status"
                      [ngClass]="tarificationCode?.progressInfos?.status === COMPLETED ? 'ok' : tarificationCode?.progressInfos?.status === WAITING ? 'wait' : tarificationCode?.progressInfos?.status === IN_PROGRESS ? 'run' : 'error'">
                  {{ getStatusHr(tarificationCode.progressInfos.status) }}
                </span>
              </div>
              @if (tarificationCode.progressInfos.status === COMPLETED) {
                <div class="meta">
                  @if (tarificationCode?.progressInfos?.injectedCode != null) {
                    <span>Créés&nbsp;: {{ tarificationCode?.progressInfos?.injectedCode }}</span>
                  }
                  @if (tarificationCode?.progressInfos?.updatedCode != null) {
                    <span>Modifiés&nbsp;: {{ tarificationCode?.progressInfos?.updatedCode }}</span>
                  }
                </div>
              }
              <div class="progress-bar"
                   [ngClass]="tarificationCode.progressInfos.status === COMPLETED ? 'green' : ''"></div>
            </div>
          }
        }
      </div>
    </div>

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <span>Autres codes</span>
        </div>
      </div>
      <div class="progress-grid">
        @for (defaultCode of availableDefaultCodeTypes; track $index) {
          @if (defaultCode?.selected) {
            <div class="progress-item">
              <div class="progress-item-txt">
                <span>{{ defaultCode.type }}</span>
                <span class="status"
                      [ngClass]="defaultCode?.progressInfos?.status === COMPLETED ? 'ok' : defaultCode?.progressInfos?.status === WAITING ? 'wait' : defaultCode?.progressInfos?.status === IN_PROGRESS ? 'run' : 'error'">
                  {{ getStatusHr(defaultCode.progressInfos.status) }}
                </span>
              </div>
              @if (defaultCode.progressInfos.status === COMPLETED) {
                <div class="meta">
                  @if (defaultCode?.progressInfos?.injectedCode != null) {
                    <span>Créés&nbsp;: {{ defaultCode?.progressInfos?.injectedCode }}</span>
                  }
                  @if (defaultCode?.progressInfos?.updatedCode != null) {
                    <span>Modifiés&nbsp;: {{ defaultCode?.progressInfos?.updatedCode }}</span>
                  }
                </div>
              }
              <div class="progress-bar"
                   [ngClass]="defaultCode.progressInfos.status === COMPLETED ? 'green' : ''"></div>
            </div>
          }
        }
      </div>
    </div>

  </div>
} @else {
  <div class="import-modal">
    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <label class="category-checkbox">
            <input type="checkbox"
                   (change)="checkAll($event?.target?.checked, 'thesaurus')" [checked]="allCodesChecked('thesaurus')"/>
            <span class="checkmark"></span>
            <span>Thésaurus</span>
          </label>
        </div>
      </div>
      <div class="checkbox-grid">
        @for (thesaurusCode of availableThesaurusCodeTypes; track $index) {
          <label class="checkbox-item">
            <input type="checkbox" [(ngModel)]="availableThesaurusCodeTypes[$index].selected"
                   [checked]="availableThesaurusCodeTypes[$index].selected"
                   (ngModelChange)="allCodesChecked('thesaurus')"/>
            <span class="checkmark"></span>
            <span>{{ thesaurusCode.type }}</span>
          </label>
        }
      </div>
    </div>

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <label class="category-checkbox">
            <input type="checkbox" (change)="checkAll($event?.target?.checked, 'insurance')"
                   [checked]="allCodesChecked('insurance')"/>
            <span class="checkmark"></span>
            <span>Assurance</span>
          </label>
        </div>
      </div>
      <div class="checkbox-grid">
        @for (insuranceCode of availableInsuranceCodeTypes; track $index) {
          <label class="checkbox-item">
            <input type="checkbox" [(ngModel)]="availableInsuranceCodeTypes[$index].selected"
                   [checked]="availableInsuranceCodeTypes[$index].selected"
                   (ngModelChange)="allCodesChecked('insurance')"/>
            <span class="checkmark"></span>
            <span>{{ insuranceCode.type }}</span>
          </label>
        }
      </div>
    </div>

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <label class="category-checkbox">
            <input type="checkbox" (change)="checkAll($event?.target?.checked, 'tarification')"
                   [checked]="allCodesChecked('tarification')"/>
            <span class="checkmark"></span>
            <span>Tarification</span>
          </label>
        </div>
      </div>
      <div class="checkbox-grid">
        @for (tarificationCode of availableTarificationCodeTypes; track $index) {
          <label class="checkbox-item">
            <input type="checkbox" [(ngModel)]="availableTarificationCodeTypes[$index].selected"
                   [checked]="availableTarificationCodeTypes[$index].selected"
                   (ngModelChange)="allCodesChecked('tarification')"/>
            <span class="checkmark"></span>
            <span>{{ tarificationCode.type }}</span>
          </label>
        }
      </div>
    </div>

    <div class="bloc">
      <div class="bloc-header">
        <div class="bloc-title">
          <label class="category-checkbox">
            <input type="checkbox" (change)="checkAll($event?.target?.checked, 'default')"
                   [checked]="allCodesChecked('default')"/>
            <span class="checkmark"></span>
            <span>Autres codes</span>
          </label>
        </div>
      </div>
      <div class="checkbox-grid">
        @for (defaultCode of availableDefaultCodeTypes; track $index) {
          <label class="checkbox-item">
            <input type="checkbox" [(ngModel)]="availableDefaultCodeTypes[$index].selected"
                   [checked]="availableDefaultCodeTypes[$index].selected" (ngModelChange)="allCodesChecked('default')"/>
            <span class="checkmark"></span>
            <span>{{ defaultCode.type }}</span>
          </label>
        }
      </div>
    </div>
  </div>
}

<div class="footer-actions">
  @if (!isImporting) {
    <button class="btn cancel" (click)="closeDialog()">Annuler</button>
    <button class="btn confirm" (click)="importSelectedCodes()">Importer les codes</button>
  }

  @if (isImporting) {
    <button class="btn cancel" (click)="closeDialog()" [disabled]="isLoading">Fermer</button>
  }

</div>
